import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { CreateShipment } from './pages/CreateShipment';
import { ShipmentDetails } from './pages/ShipmentDetails';
import { CapacitySettings } from './pages/CapacitySettings';
import { Appointments } from './pages/Appointments';
import { ShipmentsKanban } from './pages/ShipmentsKanban';
import { Reports } from './pages/Reports';
import { ReportCenter } from './pages/ReportCenter';
import { UserManagement } from './pages/UserManagement';
import { WarehouseSettings } from './pages/WarehouseSettings';
import { ApprovalQueue } from './pages/ApprovalQueue';
import { CapacityManagement } from './pages/CapacityManagement';
import { CheckInReceiving } from './pages/CheckInReceiving';
import { Notifications } from './pages/Notifications';
import { UserDetails } from './pages/UserDetails';
import { SystemSettings } from './pages/SystemSettings';
import { useScreenInit } from './useScreenInit';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Navigate } from 'react-router-dom';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    user
  } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace data-id="element-0" />;
  }
  return <>{children}</>;
}
export function App() {
  const screenInit = useScreenInit();
  return <AuthProvider data-id="element-1">
      <BrowserRouter data-id="element-2">
        <Layout data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/login" element={<Login data-id="element-6" />} data-id="element-5" />
            <Route path="/" element={<ProtectedRoute data-id="element-8">
                  <Dashboard data-id="element-9" />
                </ProtectedRoute>} data-id="element-7" />
            <Route path="/create" element={<ProtectedRoute data-id="element-11">
                  <CreateShipment data-id="element-12" />
                </ProtectedRoute>} data-id="element-10" />
            <Route path="/details" element={<ProtectedRoute data-id="element-14">
                  <ShipmentDetails data-id="element-15" />
                </ProtectedRoute>} data-id="element-13" />
            <Route path="/settings" element={<ProtectedRoute data-id="element-17">
                  <CapacitySettings data-id="element-18" />
                </ProtectedRoute>} data-id="element-16" />
            <Route path="/appointments" element={<ProtectedRoute data-id="element-20">
                  <Appointments data-id="element-21" />
                </ProtectedRoute>} data-id="element-19" />
            <Route path="/kanban" element={<ProtectedRoute data-id="element-23">
                  <ShipmentsKanban data-id="element-24" />
                </ProtectedRoute>} data-id="element-22" />
            <Route path="/reports" element={<ProtectedRoute data-id="element-26">
                  <ReportCenter data-id="element-27" />
                </ProtectedRoute>} data-id="element-25" />
            <Route path="/reports/:id" element={<ProtectedRoute data-id="element-29">
                  <Reports data-id="element-30" />
                </ProtectedRoute>} data-id="element-28" />
            <Route path="/users" element={<ProtectedRoute data-id="element-32">
                  <UserManagement data-id="element-33" />
                </ProtectedRoute>} data-id="element-31" />
            <Route path="/users/:id" element={<ProtectedRoute data-id="element-35">
                  <UserDetails data-id="element-36" />
                </ProtectedRoute>} data-id="element-34" />
            <Route path="/warehouses" element={<ProtectedRoute data-id="element-38">
                  <WarehouseSettings data-id="element-39" />
                </ProtectedRoute>} data-id="element-37" />
            <Route path="/approvals" element={<ProtectedRoute data-id="element-41">
                  <ApprovalQueue data-id="element-42" />
                </ProtectedRoute>} data-id="element-40" />
            <Route path="/capacity" element={<ProtectedRoute data-id="element-44">
                  <CapacityManagement data-id="element-45" />
                </ProtectedRoute>} data-id="element-43" />
            <Route path="/receiving" element={<ProtectedRoute data-id="element-47">
                  <CheckInReceiving data-id="element-48" />
                </ProtectedRoute>} data-id="element-46" />
            <Route path="/notifications" element={<ProtectedRoute data-id="element-50">
                  <Notifications data-id="element-51" />
                </ProtectedRoute>} data-id="element-49" />
            <Route path="/system-settings" element={<ProtectedRoute data-id="element-53">
                  <SystemSettings data-id="element-54" />
                </ProtectedRoute>} data-id="element-52" />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>;
}